import React, { useState, useRef } from 'react';
import Search from './components/Search/Search';
import Sidebar from './components/Sidebar/Sidebar';
import { Analytics } from "@vercel/analytics/react";
import './fonts.css';

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem('theme') === 'dark';
  });
  const searchRef = useRef();

  const toggleTheme = () => {
    setIsDark(!isDark);
    localStorage.setItem('theme', !isDark ? 'dark' : 'light');
  };

  const handleProjectClick = (query) => {
    if (searchRef.current?.handleSubmit) {
      searchRef.current.handleSubmit(query);
    }
  };

  return (
    <div className={`flex h-screen overflow-hidden font-relative ${isDark ? 'bg-black' : 'bg-white'}`}>
      <Analytics/>
      <Sidebar 
        isOpen={isSidebarOpen} 
        setIsOpen={setIsSidebarOpen} 
        onProjectClick={handleProjectClick}
        isDark={isDark}
        toggleTheme={toggleTheme}
      />

      <div
        className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'md:ml-40' : 'md:ml-20'
        } ml-0`}
      >
        <main className="flex-1 flex items-center justify-center px-4 md:px-5">
          <div className="w-full max-w-3xl">
            <Search ref={searchRef} isDark={isDark} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default App;